import { render, staticRenderFns } from "./GiftProductInfoList.vue?vue&type=template&id=7e997afb&scoped=true&"
import script from "./GiftProductInfoList.vue?vue&type=script&lang=js&"
export * from "./GiftProductInfoList.vue?vue&type=script&lang=js&"
import style0 from "./GiftProductInfoList.vue?vue&type=style&index=0&id=7e997afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e997afb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e997afb')) {
      api.createRecord('7e997afb', component.options)
    } else {
      api.reload('7e997afb', component.options)
    }
    module.hot.accept("./GiftProductInfoList.vue?vue&type=template&id=7e997afb&scoped=true&", function () {
      api.rerender('7e997afb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/GiftProductInfoList.vue"
export default component.exports